import clsx from 'clsx';
import React from 'react';
import { DsmColor } from '../../../constants/colors.mjs';
import { factory } from '../../../factory/factory.utils.mjs';
import { Typography } from '../../../Foundations/Typography/Typography.mjs';
import { useId } from '../../../Inputs/Dropdown/subcomponent/Combobox/use-id.mjs';
import { Flex } from '../../../Layout/Flex/Flex.mjs';
import { Box } from '../../../Other/Box/Box.mjs';
import { useUncontrolled } from '../../../utils/hooks/use-uncontrolled.mjs';
import { InputsGroupFieldset } from '../InputsGroupFieldset/InputsGroupFieldset.mjs';
import { InputWrapperProvider } from '../InputsGroupFieldset/InputWrapper.context.mjs';
import { RadioGroupProvider } from '../RadioGroup.context.mjs';
import classes from './RadioGroup.module.css.mjs';

const RadioGroup = factory((props, ref) => {
  const {
    value,
    defaultValue,
    onChange,
    children,
    name,
    label,
    error,
    id,
    radioGroupClassname,
    ["aria-label"]: ariaLabel,
    ...rest
  } = props;
  const [_value, setValue] = useUncontrolled({
    value,
    defaultValue,
    finalValue: "",
    onChange
  });
  const idBase = useId(id);
  const inputId = idBase;
  const labelId = `${idBase}-label`;
  const handleChange = (newValue) => setValue(newValue);
  const groupAriaLabelledby = label ? labelId : void 0;
  const groupAriaLabel = !label ? ariaLabel || name : void 0;
  return /* @__PURE__ */ React.createElement(
    InputWrapperProvider,
    {
      value: {
        describedBy: void 0,
        inputId,
        labelId: groupAriaLabelledby,
        ariaLabel: groupAriaLabel
      }
    },
    /* @__PURE__ */ React.createElement(RadioGroupProvider, { value: { value: _value, onChange: handleChange, name } }, /* @__PURE__ */ React.createElement(Flex, { direction: "column", gap: 20 }, label && /* @__PURE__ */ React.createElement(Typography, { component: "label", size: "label-medium-l", id: labelId, textColor: DsmColor.ContentTertiary }, label), /* @__PURE__ */ React.createElement(Box, { ref, ...rest }, /* @__PURE__ */ React.createElement(
      InputsGroupFieldset,
      {
        role: "radiogroup",
        className: clsx(classes.radioGroupInputs, radioGroupClassname, "kohler-radio-group-fieldset")
      },
      children
    )), error && /* @__PURE__ */ React.createElement(Typography, { size: "paragraph-small", textColor: DsmColor.ContentError }, error)))
  );
});

export { RadioGroup };
